// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkflowApproval } from './workflow-approval';
import {
    WorkflowApprovalFromJSON,
    WorkflowApprovalFromJSONTyped,
    WorkflowApprovalToJSON,
    WorkflowApprovalToJSONTyped,
} from './workflow-approval';

/**
 * 
 * @export
 * @interface ListDtaApprovals200Response
 */
export interface ListDtaApprovals200Response {
    /**
     * 
     * @type {Array<WorkflowApproval>}
     * @memberof ListDtaApprovals200Response
     */
    approvals: Array<WorkflowApproval>;
    /**
     * 
     * @type {number}
     * @memberof ListDtaApprovals200Response
     */
    pending_approvals: number;
    /**
     * 
     * @type {number}
     * @memberof ListDtaApprovals200Response
     */
    required_approvals: number;
}

/**
 * Check if a given object implements the ListDtaApprovals200Response interface.
 */
export function instanceOfListDtaApprovals200Response(value: object): value is ListDtaApprovals200Response {
    if (!('approvals' in value) || value['approvals'] === undefined) return false;
    if (!('pending_approvals' in value) || value['pending_approvals'] === undefined) return false;
    if (!('required_approvals' in value) || value['required_approvals'] === undefined) return false;
    return true;
}

export function ListDtaApprovals200ResponseFromJSON(json: any): ListDtaApprovals200Response {
    return ListDtaApprovals200ResponseFromJSONTyped(json, false);
}

export function ListDtaApprovals200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDtaApprovals200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'approvals': ((json['approvals'] as Array<any>).map(WorkflowApprovalFromJSON)),
        'pending_approvals': json['pending_approvals'],
        'required_approvals': json['required_approvals'],
    };
}

export function ListDtaApprovals200ResponseToJSON(json: any): ListDtaApprovals200Response {
    return ListDtaApprovals200ResponseToJSONTyped(json, false);
}

export function ListDtaApprovals200ResponseToJSONTyped(value?: ListDtaApprovals200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'approvals': ((value['approvals'] as Array<any>).map(WorkflowApprovalToJSON)),
        'pending_approvals': value['pending_approvals'],
        'required_approvals': value['required_approvals'],
    };
}
